import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const AccountantsCtaSection = () => (
    <section id="cta" className="lp-cta">
        <div className="lp-cta-card" data-lp-reveal>
            <div className="lp-cta-glow" aria-hidden="true" />
            <div className="lp-cta-inner">
                <h2>Ready to grow your clients’ value?</h2>
                <p className="sub">Join Diligentsia free — and start delivering more for every client.</p>
                <div className="lp-cta-btns">
                    <a className="lp-cta-btn" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                    <Link className="lp-cta-btn lp-cta-btn--outline" to={ROUTES.REGISTER}>Register free</Link>
                </div>
                <p className="fine">mark.bernstein@diligentsia.co.uk · diligentsia.co.uk</p>
            </div>
        </div>
    </section>
);

export default AccountantsCtaSection;
